import {createFileRoute, redirect} from '@tanstack/react-router'
import {type} from 'arktype'

import {localeAtom} from '@/lib/locale/locale'
import {expireOrder} from '@/services/orderService'
import stripDefaultSearchParams from '@/utils/router/middlewares/stripDefaultSearchParams'
import stripEmptySearchParams from '@/utils/router/middlewares/stripEmptySearchParams'
import stripZeroSearchParams from '@/utils/router/middlewares/stripZeroSearchParams'
import {fallbackToDefault} from '@/utils/schema/fallback'
import searchParamString from '@/utils/schema/searchParamString'

const DEFAULT_VALUES = {
  cancel: false,
  applyRewards: false,
  coupon: '',
}

const cartSearchSchema = type({
  orderId: searchParamString.optional(),
  cancel: fallbackToDefault(type.boolean, DEFAULT_VALUES.cancel),
  applyRewards: fallbackToDefault(type.boolean, DEFAULT_VALUES.applyRewards),
  coupon: fallbackToDefault(searchParamString, DEFAULT_VALUES.coupon),
})

export const Route = createFileRoute('/_shop/cart/')({
  validateSearch: cartSearchSchema,
  search: {
    middlewares: [
      stripDefaultSearchParams(DEFAULT_VALUES),
      stripZeroSearchParams(),
      stripEmptySearchParams(),
    ],
  },
  beforeLoad: ({search, context}) => {
    if (search.cancel && search.orderId) {
      const locale = context.store.get(localeAtom)

      void expireOrder({
        orderId: search.orderId,
        locale,
      })

      throw redirect({
        to: Route.fullPath,
        replace: true,
      })
    }
  },
})
